module.exports = __webpack_public_path__ + "img/fuse-top_256x180.da68c130.png";